import { render, staticRenderFns } from "./GenderSelection.vue?vue&type=template&id=4561406f&scoped=true"
import script from "./GenderSelection.vue?vue&type=script&lang=js"
export * from "./GenderSelection.vue?vue&type=script&lang=js"
import style0 from "./GenderSelection.vue?vue&type=style&index=0&id=4561406f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561406f",
  null
  
)

export default component.exports